export const SET_SLOTS = "SET_SLOTS";
export const RESET_SLOTS = "RESET_SLOTS";
export const UPDATE_SLOT = "UPDATE_SLOT";
export const SET_SLOT_PRODUCTS = "SET_SLOT_PRODUCTS";
export const RESET_SLOT_PRODUCTS = "RESET_SLOT_PRODUCTS";
export const ASSIGN_PRODUCTS_TO_SLOT = "ASSIGN_PRODUCTS_TO_SLOT";
export const REMOVE_PRODUCT_FROM_SLOT = "REMOVE_PRODUCT_FROM_SLOT";
export const SET_PRODUCTS_FOR_SLOTS = "SET_PRODUCTS_FOR_SLOTS";